import Control from '../components/Control/Control';

export default {
    key: 'control',
    value: Control,
};
